/**
 * Shared tree-walk helpers for `exam.tasks` — the nested `{ taskNumber, _id, subTasks }` tree, walked by a
 * separator-joined path of `taskNumber` segments (segment-by-segment against that level's own
 * `taskNumber`). Used wherever a job payload's task ref or a LanguageUseScheme's `dependsOn` entry needs
 * resolving back to the actual task node it names — see chat.tsx's live-solution-jobs derivation
 * (dot-separated refs) and use-grading-state.ts's languageUse dependency check (pipe-separated paths).
 */

/** Walks `tasks` by `path`'s `separator`-joined `taskNumber` segments; returns the matched node, or
 * `undefined` if any segment has no match at that level. */
export function findTaskTreeNode(tasks: any[], path: string, separator: string): any | undefined {
  let level: any[] = Array.isArray(tasks) ? tasks : [];
  let node: any;
  for (const segment of path.split(separator)) {
    node = level.find((t: any) => String(t?.taskNumber) === segment);
    if (!node) return undefined;
    level = Array.isArray(node.subTasks) ? node.subTasks : [];
  }
  return node;
}

/** Every node's own `_id` across `nodes` and their whole `subTasks` subtree. */
export function collectTaskTreeNodeIds(nodes: any[]): string[] {
  const ids: string[] = [];
  const walk = (list: any[]) => {
    for (const node of list) {
      if (node?._id) ids.push(String(node._id));
      if (Array.isArray(node?.subTasks)) walk(node.subTasks);
    }
  };
  walk(Array.isArray(nodes) ? nodes : []);
  return ids;
}
